var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import WhoCreated from "@irati-web/recognition/src/components/WhoCreated";
import { H3 } from "@irati/ui/src/Headings";
import { Para, SmallCaption } from "@irati/ui/src/Labels";
import DateFilter from "@irati/ui/src/DateFilter";
import { PB_LAST_COLUMN } from "@irati/ui/src/Table";
import { formatCurrency } from "@irati/utils/currency/formatCurrency";
import AmountHeader from "./AmountHeader";
import RemainingBalanceHeader from "./RemainingBalanceHeader";
import NameHeader from "./NameHeader";
var StyledSmallCaption = styled(SmallCaption)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  top: -15px;\n  left: 30px;\n"], ["\n  position: relative;\n  top: -15px;\n  left: 30px;\n"])));
var Columns = function (_a) {
    var formatMessage = _a.formatMessage, updateDate = _a.updateDate, updateUsers = _a.updateUsers, updateAmount = _a.updateAmount;
    var cols = [
        {
            Header: React.createElement(DateFilter, { onChange: updateDate }),
            accessor: "date"
        },
        {
            Header: formatMessage({ id: "admin.reportingV2.wallet.columns.method.title" }),
            accessor: "method",
            Cell: function (_a) {
                var value = _a.value;
                return formatMessage({ id: "admin.reportingV2.wallet.columns.method.type." + value });
            }
        },
        {
            Header: formatMessage({ id: "admin.reportingV2.wallet.columns.actionedBy.title" }),
            accessor: "by",
            Cell: function (_a) {
                var value = _a.value;
                if (!value) {
                    return;
                }
                return React.createElement(WhoCreated, { createdBy: value, size: "24px" });
            },
            style: { alignItems: "center" }
        },
        {
            Header: React.createElement(NameHeader, { title: formatMessage({ id: "admin.reportingV2.wallet.columns.to.title" }), onChange: updateUsers }),
            id: "to",
            accessor: function (row) {
                if (!row.to) {
                    return;
                }
                return (React.createElement(React.Fragment, null,
                    React.createElement(WhoCreated, { createdBy: row.to, size: "24px" }),
                    React.createElement(StyledSmallCaption, { uppercase: true }, formatMessage({ id: "admin.reportingV2.wallet.columns.to." + row.senderRecipientType }))));
            }
        },
        {
            Header: React.createElement(AmountHeader, { onChange: updateAmount }),
            accessor: "amount",
            Cell: function (_a) {
                var value = _a.value;
                return React.createElement(Para, { bold: true }, formatCurrency({ value: value }));
            }
        }
    ];
    return cols;
};
var RewardColumns = function (_a) {
    var _b;
    var formatMessage = _a.formatMessage, updateUsers = _a.updateUsers, updateBalance = _a.updateBalance;
    var cols = [
        {
            Header: React.createElement(NameHeader, { onChange: updateUsers, jobRole: "manager" }),
            accessor: "user",
            style: { overflow: "visible" },
            Cell: function (_a) {
                var value = _a.value;
                return value ? React.createElement(WhoCreated, { createdBy: value, size: "24px" }) : React.createElement("div", null);
            }
        },
        {
            Header: formatMessage({ id: "admin.reportingV2.wallet.columns.moneyGiven.title" }),
            id: "given",
            accessor: function (row) { return (row.user ? React.createElement(Para, null, formatCurrency({ value: row.given })) : React.createElement(H3, null, formatCurrency({ value: row.given }))); }
        },
        {
            Header: formatMessage({ id: "admin.reportingV2.wallet.columns.moneySpent.title" }),
            id: "spent",
            accessor: function (row) { return (row.user ? React.createElement(Para, null, formatCurrency({ value: row.spent })) : React.createElement(H3, null, formatCurrency({ value: row.spent }))); }
        },
        (_b = {
                Header: React.createElement(RemainingBalanceHeader, { onChange: updateBalance }),
                id: "balance"
            },
            _b[PB_LAST_COLUMN] = true,
            _b.accessor = function (row) { return (row.user ? React.createElement(Para, null, formatCurrency({ value: row.balance })) : React.createElement(H3, null, formatCurrency({ value: row.balance }))); },
            _b)
    ];
    return cols;
};
var PeopleColumns = function (_a) {
    var formatMessage = _a.formatMessage, updateUsers = _a.updateUsers;
    var cols = [
        {
            Header: React.createElement(NameHeader, { onChange: updateUsers }),
            id: "user",
            accessor: function (_a) {
                var user = _a.user;
                return React.createElement(WhoCreated, { createdBy: user, size: "24px" });
            }
        },
        {
            Header: "Teams",
            id: "team",
            accessor: function (_a) {
                var user = _a.user;
                return (React.createElement(Para, null, user.teams && user.teams.results.length > 0 && user.teams.results.map(function (team) { return team.public_name; }).join(", ")));
            },
            width: 200
        },
        {
            Header: formatMessage({ id: "admin.reportingV2.wallet.columns.remainingBalance.title" }),
            accessor: "remainingBalance",
            Cell: function (_a) {
                var value = _a.value;
                return React.createElement(Para, { bold: true }, formatCurrency({ value: value }));
            }
        },
        {
            Header: formatMessage({ id: "admin.reportingV2.wallet.columns.creditRewarded.title" }),
            accessor: "creditRewarded",
            Cell: function (_a) {
                var value = _a.value;
                return React.createElement(Para, null, formatCurrency({ value: value }));
            }
        },
        {
            Header: formatMessage({ id: "admin.reportingV2.wallet.columns.giftCardValueRewarded.title" }),
            accessor: "giftCardValueRewarded",
            Cell: function (_a) {
                var value = _a.value;
                return React.createElement(Para, null, formatCurrency({ value: value }));
            }
        },
        {
            Header: formatMessage({ id: "admin.reportingV2.wallet.columns.creditSpent.title" }),
            accessor: "creditSpent",
            Cell: function (_a) {
                var value = _a.value;
                return React.createElement(Para, null, formatCurrency({ value: value }));
            }
        },
        {
            Header: formatMessage({ id: "admin.reportingV2.wallet.columns.perksGOSavings.title" }),
            accessor: "perksGoSavings",
            Cell: function (_a) {
                var value = _a.value;
                return React.createElement(Para, null, formatCurrency({ value: value }));
            }
        }
    ];
    return cols;
};
export { RewardColumns };
export { PeopleColumns };
export default Columns;
var templateObject_1;
